import { render, staticRenderFns } from "./FormTel.vue?vue&type=template&id=7106ea40&"
import script from "./FormTel.vue?vue&type=script&lang=ts&"
export * from "./FormTel.vue?vue&type=script&lang=ts&"
import style0 from "./FormTel.vue?vue&type=style&index=0&id=7106ea40&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports